<template>
  <div>
    <b-list-group-item v-bind:key="user.userId" class="d-flex align-items-center job-list-card">
        <user-image :user="user.user" ></user-image>
        <!-- <img alt="User Image" class="avatar avatar-md media-comment-avatar rounded-circle mx-2 my-0" :src="userAvatar"> -->
        <div class="ml-2 w-50">{{ userName }}</div>
        <!-- <b-dropdown :text="assignedRoleName" variant="outline-primary" size="sm" class="ml-auto" :disabled="assignableRoles.length === 0">
          <b-dropdown-item v-for="role in assignableRoles" :key="role.roleId">{{role.details.name}}</b-dropdown-item>
        </b-dropdown> -->
        <div class="ml-auto">
          <b-form-select
              v-model="user.accountRoleId"
              :options="roleOptions"
              :disabled="mayAssignRoles"
              @change="modalConfirmRoleChange"
              size="sm"
          >
          </b-form-select>
        </div>

        <b-button :disabled="!mayRemove" size="sm" variant="outline-danger" class="mx-2" @click="modalConfirmUserRemoval">X</b-button>
    </b-list-group-item>
  </div>
</template>

<script>
import { RoleModifyUserRequest, RoleRemoveUserRequest, AccountRoleRequest } from '#/protobuf/service_account_pb';
import UserImage from '../User/UserImage.vue';

export default {
  components: { UserImage },
  props: {
    user: {
      type: Object,
      required: true,
    },
    allRoles: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      originalRole: 0,
    };
  },
  created() {
    this.originalRole = this.user.accountRoleId;
  },
  computed: {
    userAvatar() {
      return this.user.user.userPictureUrl;
    },
    userName() {
      const name = this.user.user.userNickname ? this.user.user.userNickname : `${this.user.user.userFirstName} ${this.user.user.userLastName}`;
      return name.trim() !== '' ? name : this.user.user.email;
    },
    roleOptions() {
      return this.allRoles.map((role) => ({
        value: role.roleId,
        text: role.details.name,
        disabled: role.roleId === 0 || !this.user.assignableAccountRolesList.includes(role.roleId),
      }));
    },
    assignableRoles() {
      return this.allRoles.filter((role) => this.user.assignableAccountRolesList.includes(role.roleId));
    },
    assignedRole() {
      return this.allRoles.find((r) => this.user.accountRoleId === r.roleId);
    },
    // assignedRoleId() {
    //   return this.user.accountRoleId;
    // },
    assignedRoleName() {
      return this.assignedRole.details.name;
    },
    mayAssignRoles() {
      return this.assignableRoles && this.assignableRoles.length === 0;
    },
    mayRemove() {
      return this.user.mayRemoveFromAccount;
    },
  },
  methods: {
    modalConfirmUserRemoval() {
      this.$bvModal.msgBoxConfirm(`Do you really want to remove ${this.userName} from this account?`, {
        title: 'Remove User',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        headerClass: 'align-items-center',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      }).then((userAcceptedRemoval) => {
        if (userAcceptedRemoval) {
          this.$emit('remove-account-user', this.user.user.userId);
        }
      }).catch((err) => {
        // TODO: need to show error to user
        console.warn('error while removing user', this.user, err);
      });
    },
    modalConfirmRoleChange(roleId) {
      console.log('prompting user about role change', roleId);
      this.$bvModal.msgBoxConfirm(`Do you really want change this user's permissions to: ${this.assignedRoleName}?`, {
        title: 'Update Permissions',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'primary',
        okTitle: 'Update',
        cancelTitle: 'Cancel',
        headerClass: 'align-items-center',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
      }).then((userAccepted) => {
        if (userAccepted) {
          this.changeRole(roleId);
        }
      }).catch((err) => {
        console.warn('error while handling user role change modal', this.user, err);
      });
    },
    changeRole(roleId) {
      console.log('changing role to:', roleId);
      const request = new RoleModifyUserRequest();
      const accountRole = new AccountRoleRequest();
      accountRole.setAccountRoleId(roleId);
      request.setAccountModification(accountRole);
      request.setUserId(this.user.user.userId);
      return this.$store.dispatch('accounts/modifyUserRole', request).then((response) => {
        console.log('RESPONSE modifyUserRole', response);
        // this.$nextTick(() => {
        //   this.email = '';
        //   // this.$bvModal.hide('invite-user-modal');
        // });
      }).catch((error) => {
        console.log('modifyUserRole error', error.message);
        // this.invalidText = error.message;
      });
    },
  },
};
</script>

<style scoped>
/* .item {
  cursor: pointer;
}
.bold {
  font-weight: bold;
}
ul {
  padding-left: 1em;
  line-height: 1.5em;
  list-style-type: dot;
} */
</style>
